import { OverlayPanel } from 'primereact/overlaypanel';

export default OverlayPanel;